import { Node } from '@tiptap/core';

export const StyledHeading = Node.create({
  name: 'styledHeading',
  group: 'block',
  content: 'inline*',
  priority: 1000, // High priority to ensure it's used - updated

  addAttributes() {
    return {
      level: {
        default: 1,
        rendered: false,
      },
      style: {
        default: null,
        parseHTML: (element) => element.getAttribute('style'),
        renderHTML: (attributes) => {
          if (!attributes.style) {
            return {};
          }
          return {
            style: attributes.style,
          };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'h1',
        getAttrs: (element) => {
          return { level: 1 };
        },
      },
      {
        tag: 'h2',
        getAttrs: (element) => {
          return { level: 2 };
        },
      },
      {
        tag: 'h3',
        getAttrs: (element) => {
          return { level: 3 };
        },
      },
      {
        tag: 'h4',
        getAttrs: (element) => {
          return { level: 4 };
        },
      },
      {
        tag: 'h5',
        getAttrs: (element) => {
          return { level: 5 };
        },
      },
      {
        tag: 'h6',
        getAttrs: (element) => {
          return { level: 6 };
        },
      },
    ];
  },

  renderHTML({ node, HTMLAttributes }) {
    const level = node.attrs.level || 1;
    return [`h${level}`, HTMLAttributes, 0];
  },

  addCommands() {
    return {
      setStyledHeading:
        (attributes) =>
        ({ commands }) => {
          return commands.setNode(this.name, attributes);
        },
      setHeading:
        (attributes) =>
        ({ commands }) => {
          return commands.setNode(this.name, attributes);
        },
      toggleHeading:
        (attributes) =>
        ({ commands }) => {
          return commands.toggleNode(this.name, 'paragraph', attributes);
        },
    };
  },
});
